module.exports = __webpack_public_path__ + "static/background-particles-a936abb825444a4bfb75acb94d65cd64.gif";